import * as React from 'react';
import { AgentsPanel } from './AgentsPanel';
import { SwarmPanel } from './SwarmPanel';
import { SeatPanel } from './SeatPanel';
import { KeysPanel } from './KeysPanel';
import { DASH_CSS, Surface, SurfaceHeader } from './ui';

const TABS: Record<string, { title: string; Panel: React.ComponentType }> = {
  routing: { title: 'Agents — which engine each one drives', Panel: AgentsPanel },
  models: { title: 'Swarm — the models we run on', Panel: SwarmPanel },
  seat: { title: "Seat — customers' own Claude plans", Panel: SeatPanel },
  keys: { title: 'Keys — the credentials everything runs on', Panel: KeysPanel },
};

export const MACHINE_SETTINGS_TABS = Object.keys(TABS);

export default function MachineSettingsTab({ tab }: { tab: string }) {
  const entry = TABS[tab];
  if (!entry) return null;
  const { title, Panel } = entry;
  return (
    <div className="aa-dash">
      <style>{DASH_CSS}</style>
      <Surface>
        <SurfaceHeader title={title} />
        <div className="p-[18px]">
          <Panel />
        </div>
      </Surface>
    </div>
  );
}
